import * as config from '../config';
export const SUBSCRIPTION_URL = 'tools/contacts';
export const SUBSCRIPTION_CONFIRM_URL = 'alert/contacts/subscribe';
export const API_REQUEST_URL = `${config.API_ENDPOINT}/${config.API_PREFIX}`;
